// extracted by mini-css-extract-plugin
var _1 = "DashboardTileDelta-moduledelta__StEgZ";
var _2 = "DashboardTileDelta-moduleerror__sPmYA";
var _3 = "DashboardTileDelta-modulesuccess__N75PN";
export { _1 as "delta", _2 as "error", _3 as "success" }
